import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { useTheme } from "styled-components";
import { Typo } from "../typography";
import { Button, buttonHeights } from "../button";
// styles
import warning from "warning";
import { StyledContentBox, Subtitle } from "./contentbox.styles";
export function ContentBox({ emphasize, button, title, subtitle, color, isTypeB, position = "top", isSeoConformCarousel, index, }) {
    const theme = useTheme();
    const headlineRef = useRef(null);
    const sublineRef = useRef(null);
    let headline = (title === null || title === void 0 ? void 0 : title.length) > 30 ||
        (subtitle === null || subtitle === void 0 ? void 0 : subtitle.length) > 30 ||
        (isSeoConformCarousel && index !== 0)
        ? "h2"
        : "h1";
    if (isSeoConformCarousel && index === 0) {
        headline = "h1";
    }
    function countLines() {
        const titleWrapperHeight = headlineRef.current.getBoundingClientRect().height;
        const sublineWrapperHeight = sublineRef.current.getBoundingClientRect().height;
        const titleLineHeight = Number(window.getComputedStyle(headlineRef.current).lineHeight.replace("px", ""));
        const sublineLineHeight = Number(window.getComputedStyle(sublineRef.current).lineHeight.replace("px", ""));
        const isTitleTwoLines = titleWrapperHeight <= titleLineHeight * 2;
        const isSublineTwoLines = sublineWrapperHeight <= sublineLineHeight * 2;
        return {
            isTitleTwoLines,
            isSublineTwoLines,
        };
    }
    useEffect(() => {
        if (headlineRef.current) {
            const { isSublineTwoLines, isTitleTwoLines } = countLines();
            warning(isSublineTwoLines && isTitleTwoLines, `Your headline or subline could be longer than two lines, please check. (Max two lines per title allowed.)`);
        }
    }, []);
    return (_jsxs(StyledContentBox, Object.assign({ position: position, color: color, animation: !isTypeB }, { children: [_jsxs(Typo, Object.assign({ variant: headline, fontWeight: emphasize === "title"
                    ? theme.fontWeights.bold
                    : theme.fontWeights.light }, { children: [_jsx("span", Object.assign({ ref: headlineRef }, { children: title === null || title === void 0 ? void 0 : title.slice(0, 50) })), _jsx(Subtitle, Object.assign({ ref: sublineRef, fontWeight: emphasize === "subtitle"
                            ? theme.fontWeights.bold
                            : theme.fontWeights.light }, { children: subtitle === null || subtitle === void 0 ? void 0 : subtitle.slice(0, 50) }))] })), button && (_jsx(Button, Object.assign({}, button, { stylingType: color === "white" ? "secondary" : "flatInverted", height: { xsmall: buttonHeights.medium } }, { children: button.text })))] })));
}
